import React from 'react';
import { connect } from 'react-redux';
import { deleteGroup } from '../../../../actions/group.js';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';

@connect()
export default class ContentDeleteGroup extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  deletecurrentGroup = (roomId) => {
    this.props.dispatch(deleteGroup(roomId));
  };

  openDeleteHelp = () => {
    window.open(APP.EXTERNAL_LINKS.ViewGroup.HelpDeleteGroup, '_blank');
  };

  render() {
    let centerContent = {};
    let groupName = this.props.groupForm.name;
    let bottomContent = {};

    centerContent = (
      <div className=" ui pdtm  pdlnull  segment ignored info attached message  borderless  max-width brdr-radius-null mrbl hidden-when-too-small pdbl bg-transparent">
        <h3 className="ui header">
          <span className="mrts no-bold text-size-ml">
            <i className="ui circle info icon text-size-l" />
            &nbsp;{APP.LANGUAGE.DeleteGroup.InfoPartOne} &nbsp;
            {APP.LANGUAGE.DeleteGroup.InfoPartTwo}
          </span>
        </h3>
      </div>
    );
    bottomContent = (
      <div className="pdnull ui mrblll segment ignored info attached message  borderless max-width brdr-radius-null pdrnull ">
        <h3 className="ui header">
          <span className="mrts no-bold text-size-ml">
            <i className="ui circle info icon text-size-l" />
            &nbsp;{APP.LANGUAGE.DeleteGroup.InfoPartOne} &nbsp;
            {APP.LANGUAGE.DeleteGroup.InfoPartTwo}
          </span>
        </h3>
      </div>
    );
    return (
      <div className="ui modal delete-group">
        <PopupHeader
          title={APP.LANGUAGE.DeleteGroup.Title}
          subtitle={this.props.groupForm.name + ' (' + this.props.groupForm.organisationName + ')'}
          helpFunc={this.openDeleteHelp}
        />

        <div className="content mrbl">
          <div className="main-ui-container group-delete">
            <div id="righthandfloatingpanel">
              <div className="right ui rail">
                <div className="ui sticky">
                  <RightPanel deletecurrentGroup={this.deletecurrentGroup} groupForm={this.props.groupForm} />
                </div>
              </div>
              {centerContent}
              <div className="bottom-rail-with-left-and-right-content mrtnull">
                <RightPanel deletecurrentGroup={this.deletecurrentGroup} groupForm={this.props.groupForm} />
                {bottomContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
